import styles from "./JsonBlock.module.css";

export default function JsonBlock() {
  return <pre className={styles.block} aria-label="json block" />;
}
